import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export function useLocationTestId(id: string) {
    const { pathname } = useLocation()

    const prefix = useMemo(
        () => pathname.replace(/\//g, '__').replace(/^__/, ''),
        [pathname],
    )

    return `${prefix}__${id}`
}
